/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyImplantBillItem from './pharmacy-implant-bill-item';
import PharmacyImplantBillItemDetail from './pharmacy-implant-bill-item-detail';
import PharmacyImplantBillItemUpdate from './pharmacy-implant-bill-item-update';
import PharmacyImplantBillItemDeleteDialog from './pharmacy-implant-bill-item-delete-dialog';

const PharmacyImplantBillItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyImplantBillItem />} />
    <Route path="new" element={<PharmacyImplantBillItemUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyImplantBillItemDetail />} />
      <Route path="edit" element={<PharmacyImplantBillItemUpdate />} />
      <Route path="delete" element={<PharmacyImplantBillItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyImplantBillItemRoutes;
